import ClockIcon from "@svg/new-design/clock";
import Graduated from "@svg/new-design/graduated";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import MedalIcon from "@svg/new-design/medal";
import { FC } from "react";
import ArrowLeft from "@svg/new-design/arrow-left";
import classNames from "classnames";
import UserBoard from "@svg/new-design/user-board";
import { IInstructor } from "@shared/components/card/types";
import { productCardDurationCalculator } from "@shared/components/card/helpers";
import {
  ICON_COLOR,
  ICON_SIZE,
  ICON_VARIANT,
  IconButton,
} from "@shared/components/icon-button";

interface Props {
  duration: {
    hours?: number;
    in_minutes?: number;
    minutes?: number;
    rounded_in_hour?: number;
  };
  total_orders: number | undefined;
  hasCertificate: boolean;
  instructor: IInstructor[] | undefined;
  student_count?: number;
}

const Divider = () => <div className="h-4  bg-fds-disable w-px   " />;

const ProductBody: FC<Props> = (props) => {
  const { duration, total_orders, hasCertificate, student_count } = props;
  const durationLabel = productCardDurationCalculator(duration);
  const renderClock = Boolean(durationLabel);

  const showStudenCount = Boolean(total_orders || student_count);
  const studentCount = showStudenCount
    ? Number(total_orders || student_count || 0)
    : 0;

  return (
    <div className="md:min-h-14 lg:mt-2 mt-1.5">
      {hasCertificate && (
        <div className="rounded-full lg:mb-2 mb-1.5  h-5 items-center md:w-[76px] w-[63px] lg:px-1 px-0.5 bg-fds-brand-light flex lg:gap-x-1 text-fds-on-brand-light">
          <MedalIcon className="md:w-3.5 md:h-3.5 h-3  w-3" />
          <p className="md:body-sm body-xxsm text-fds-on-brand-light">
            گواهینامه
          </p>
        </div>
      )}

      <div className="flex md:gap-x-3 gap-x-1.5 md:items-center md:h-7  ">
        {showStudenCount ? (
          <div className="items-center flex gap-x-1 ">
            <Graduated className="md:w-5 md:block hidden md:h-5 h-4 w-4 text-fds-icon-tertiary" />
            <UserBoard className="md:w-5 md:hidden block md:h-5 h-4 w-4 text-fds-icon-tertiary" />
            <p className="md:body-md  body-xxsm text-fds-secondary">
              {`${separateMoneyNumbers(toFarsiNumber(studentCount))} `}
              دانشجو
            </p>
          </div>
        ) : null}
        {showStudenCount && renderClock && <Divider />}
        {renderClock ? (
          <div className="items-center flex gap-x-1 ">
            <ClockIcon className="md:w-5    md:h-5    h-4     w-4     text-fds-icon-tertiary " />
            <p className="md:body-md body-xxsm text-fds-secondary">
              {toFarsiNumber(durationLabel)}
            </p>
          </div>
        ) : null}
        {hasCertificate && (
          <IconButton
            variant={ICON_VARIANT.DEFAULT}
            color={ICON_COLOR.BRAND}
            size={ICON_SIZE.MEDIUM}
            icon={<ArrowLeft />}
            iconClassName="w-4  text-fds-icon-brand    h-4     md:w-5    md:h-5    "
            className="self-end pt-3 mr-auto hidden md:flex "
            aria-label="بازگشت"
          />
        )}
      </div>

      <IconButton
        variant={ICON_VARIANT.DEFAULT}
        color={ICON_COLOR.BRAND}
        size={ICON_SIZE.MEDIUM}
        icon={<ArrowLeft />}
        iconClassName="w-4  text-fds-icon-brand    h-4     md:w-5    md:h-5    "
        className={classNames(
          "absolute hidden md:flex md:bottom-2.5  lg:bottom-2 lg:left-2 md:left-4 left-0 bottom-0 py-2",
          hasCertificate ? "md:hidden" : ""
        )}
        aria-label="بازگشت"
      />
      <IconButton
        variant={ICON_VARIANT.DEFAULT}
        color={ICON_COLOR.BRAND}
        size={ICON_SIZE.SMALL}
        icon={<ArrowLeft />}
        iconClassName="!w-4  text-fds-icon-brand    !h-4     md:w-5    md:h-5    "
        className="absolute hidden fds-lsm:flex md:!hidden left-0 bottom-0 py-2"
        aria-label="بازگشت"
      />
    </div>
  );
};

export default ProductBody;
